import SearchIcon from '@atlaskit/icon/core/search';
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
import { useEffect, useState } from 'react';

export const SEARCH_DEBOUNCE_VALUE = 500;

const searchWrapperStyles = xcss({
	width: '100%',
	marginBottom: 'space.100',
});

type SearchInputProps = {
	onSearch: (search: string) => void;
	placeholder?: string;
	testId: string;
};
export const SearchInput = ({ onSearch, placeholder, testId }: SearchInputProps) => {
	const [search, setSearch] = useState('');

	useEffect(() => {
		if (search === '') {
			onSearch('');
		}

		const searchHandler = setTimeout(() => {
			if (search) {
				onSearch(search);
			}
		}, SEARCH_DEBOUNCE_VALUE);

		return () => {
			clearTimeout(searchHandler);
		};
	}, [search, onSearch]);

	return (
		<Box xcss={searchWrapperStyles}>
			<Textfield
				testId={testId ? `${testId}-search-input` : undefined}
				id="search-input"
				onChange={(e) => {
					setSearch(e.currentTarget.value);
				}}
				placeholder={placeholder ?? 'Search'}
				value={search}
				elemBeforeInput={
					<Box as="span" paddingInlineStart="space.100">
						<SearchIcon label="" color={token('color.icon')} />
					</Box>
				}
				autoComplete="off"
			/>
		</Box>
	);
};
